import { createFileRoute } from '@tanstack/react-router'
import { AppHeader } from '@/shared/components/layout/AppHeader'
import { useAppStore, selectSession } from '@/shared/stores/appStore'
import { useMyProfile } from '@/features/home/queries'
import { useMyPersonalData } from '@/features/profile/queries'
import { AccountTabs } from '@/features/profile/components/AccountTabs'
import { IdentityHeader } from '@/features/profile/components/IdentityHeader'
import { PersonalDataForm } from '@/features/profile/components/PersonalDataForm'
import { PixKeyForm } from '@/features/profile/components/PixKeyForm'
import styles from './profile.module.css'

export const Route = createFileRoute('/_authenticated/profile')({
  component: ProfilePage,
})

function ProfilePage() {
  const session = useAppStore(selectSession)
  const { data: profile } = useMyProfile()
  const { data: personal, isPending, isError, refetch } = useMyPersonalData()

  return (
    <>
      <AppHeader title="Perfil" />
      <div className={styles.page}>
        <AccountTabs />

        {isPending ? (
          <div className={styles.skeleton} aria-busy="true" />
        ) : isError ? (
          <div className={styles.errorState}>
            <p>Não foi possível carregar seus dados.</p>
            <button className={styles.retry} onClick={() => void refetch()}>Tentar novamente</button>
          </div>
        ) : (
          <>
            <IdentityHeader
              fullName={personal.fullName}
              displayName={profile?.displayName ?? 'Você'}
              email={session?.user.email}
              kycStatus={personal.kycStatus}
            />

            {personal.kycStatus === 'PENDING' && (
              <div className={styles.kycBanner} role="note">
                <span className={styles.kycIcon} aria-hidden="true">🔐</span>
                <div>
                  <div className={styles.kycTitle}>Complete seus dados para ligas pagas</div>
                  <p className={styles.kycDesc}>
                    Para entrar em ligas com premiação e receber prêmios via{' '}
                    <strong className={styles.money}>Pix</strong>, precisamos do seu nome completo,
                    CPF e uma chave Pix. Esses dados ficam visíveis somente para você.
                  </p>
                </div>
              </div>
            )}

            <PersonalDataForm data={personal} />
            <PixKeyForm data={personal} />
          </>
        )}
      </div>
    </>
  )
}
